import React from "react";
import { useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";

import { Button } from "../../../components/ui/button";

interface Props {
  eyebrow: string;
  title: string;
  backTo: string;
  action?: React.ReactNode;
}

/** Cabeçalho padrão das páginas do admin (mesmo padrão de Veículos/Motoristas). */
export default function PageHeader({ eyebrow, title, backTo, action }: Props) {
  const navigate = useNavigate();
  return (
    <header className="mb-6 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={() => navigate(backTo)}
          aria-label="Voltar"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">{eyebrow}</p>
          <h1 className="text-2xl font-semibold">{title}</h1>
        </div>
      </div>
      {action}
    </header>
  );
}
